<template>
  <div class="b-page__tab">
    <div class="px-0 b-page__aside">
      <div class="py-4 px-6 b-counterparty-tab__aside-search">
        <input
          type="text"
          class="b-input"
          v-model="searchCounterparty"
          :placeholder="$t('CONTENT.search')"
        />
      </div>

      <div class="b-page__aside-list">
        <div
          v-for="(item, index) in allCounterpartiesForDirectories"
          :key="index"
        >
          <Sidebar :item="item" />
        </div>
      </div>
    </div>

    <div class="b-page__content">
      <main class="b-main__inner">
        <!-- TOOLBAR -->
        <div class="py-4 px-8 b-toolbar">
          <div class="b-toolbar__inner">

            <!-- CREATE -->
            <div class="mr-4 b-toolbar__item">
              <button
                data-cy="create-counterparty"
                class="b-btn b-btn_type_primary"
                @click="addLocalPersonForm"
              >
                <dynamic-icon
                  class="b-btn__icon b-btn__icon_color_white"
                  icon="plus"
                />
                {{ $t('CONTENT.counterparty.create_counterparty') }}
              </button>
            </div>

            <!-- IMPORT -->
            <div class="mr-4 b-toolbar__item b-import__choose">
              <ButtonWithDropdown
                :importData="importData"
                :btnText="$t('CONTENT.import')"
                iconName="xls"
                @onChooseValue="onImportChoose"
              />
            </div>

            <div class="mr-4 b-toolbar__item b-import__choose">
              <ButtonWithDropdown
                :importData="templateData"
                :btnText="$t('CONTENT.download_template')"
                iconName="download"
                @onChooseValue="onTemplateChoose"
              />
            </div>

            <!-- EXPORT -->
            <div class="b-toolbar__item b-import__choose">
              <ButtonWithDropdown
                :importData="exportData"
                :btnText="$t('CONTENT.export')"
                iconName="download"
                @onChooseValue="onExportChoose"
              />
            </div>

          </div>
        </div>

        <server-error :error="error" />

        <ContentView
          v-if="getCurrentCounterpartyIdInDB"
          :item="counterpartyForContent"
          :history="currentCounterpartyHistory"
          :is-read-only-mode="isReadOnlyMode"
          @edit="editHandler"
        />

        <!-- COUNTERPARTY FORM -->
        <popup name="counterparty-popup" height="auto" :scrollable="true">
          <server-error :error="error" />
          <GeneralForm
            v-if="isCounterPartyShow"
            :counterparty="counterpartyForForm"
            :counterpartyVatHistoryList="counterpartyVatHistoryList"
            @close="closeCounterPartyDialog"
            @openVatSettings="openVatSettings"
            @updateVatRates="updateVatRates"
          />
        </popup>

        <!-- VAT SETTINGS -->
        <popup name="vat-settings-popup" height="auto" :scrollable="true">
          <VatSettingsForm
            v-if="isVatSettingsOpen"
            :rates="counterpartyVatHistoryList"
            :counterparty-type-id="counterpartyForForm ? counterpartyForForm.idInDB : null"
            :is-create="!counterpartyForForm || !counterpartyForForm.idInDB"
            @close="closeVatSettings"
            @saveVatRates="updateVatRates"
          />
        </popup>
      </main>
    </div>

    <!-- IMPORT POPUPS -->
    <popup name="counterparty-import-popup" height="auto" :scrollable="true">
      <ImportDialogWidget
        v-if="isShowImportDialog"
        importType="counterparty"
        @close="closeImportDialog"
      />
    </popup>

    <popup name="counterparty-vat-import-popup" height="auto" :scrollable="true">
      <ImportDialogWidget
        v-if="isShowImportVatDialog"
        importType="counterpartyVat"
        @close="closeImportDialog"
      />
    </popup>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Sidebar from './Sidebar';
import ContentView from './Content';
import GeneralForm from './edit/GeneralForm';
import VatSettingsForm from './edit/VatSettingsForm';
import ImportDialogWidget from '../../widgets/ImportDialogWidget';
import ButtonWithDropdown from '../../shared/ButtonWithDropdown';
import downloadFileMixin from '../../../mixins/downloadFile';

export default {
  components: {
    Sidebar,
    ContentView,
    GeneralForm,
    VatSettingsForm,
    ImportDialogWidget,
    ButtonWithDropdown
  },

  mixins: [downloadFileMixin],

  data() {
    return {
      error: null,
      isReadOnlyMode: true,

      isCounterPartyShow: false,
      counterpartyForForm: null,

      isShowImportDialog: false,
      isShowImportVatDialog: false,

      isVatSettingsOpen: false,
      counterpartyVatHistoryList: [],

      searchCounterparty: null,
      searchCounterparties: []
    };
  },

  created() {
    const role = localStorage.getItem('role');
    if (role === 'Admin') {
      this.isReadOnlyMode = false;
    }
  },

  computed: {
    ...mapGetters([
      'allCounterparties',
      'allCounterpartiesHistory',
      'getCurrentCounterpartyIdInDB'
    ]),

    allCounterpartiesForDirectories() {
      return !this.searchCounterparty
        ? this.allCounterparties
        : this.searchCounterparties;
    },

    counterpartyForContent() {
      return this.allCounterpartiesForDirectories.find(
        x => x.idInDB === this.getCurrentCounterpartyIdInDB
      );
    },

    currentCounterpartyHistory() {
      return this.allCounterpartiesHistory.filter(
        x => x.counterpartyId === this.getCurrentCounterpartyIdInDB
      );
    },

    /* DROPDOWN DATA */

    importData() {
      return [
        {
          text: this.$t('CONTENT.counterparty.counterparty'),
          value: 'counterparty'
        },
        {
          text: this.$t('CONTENT.import_vat'),
          value: 'counterpartyVat'
        }
      ];
    },

    templateData() {
      return [
        {
          text: this.$t('CONTENT.download_counterparty_template'),
          value: 'counterparty'
        },
        {
          text: this.$t('CONTENT.download_vat_template'),
          value: 'counterpartyVat'
        }
      ];
    },

    exportData() {
      return [
        {
          text: this.$t('CONTENT.vat_and_counterparties'),
          value: 'allVatCounterparties'
        }
      ];
    }
  },

  watch: {
    async searchCounterparty(val) {
      if (val) {
        this.searchCounterparties = await this.$store.dispatch(
          'searhCounterparty',
          val
        );
      }
    }
  },

  methods: {
    /* IMPORT */

    onImportChoose(type) {
      if (type === 'counterparty') {
        this.isShowImportDialog = true;
        this.$modal.show('counterparty-import-popup');
      }

      if (type === 'counterpartyVat') {
        this.isShowImportVatDialog = true;
        this.$modal.show('counterparty-vat-import-popup');
      }
    },

    /* TEMPLATE */

    onTemplateChoose(type) {
      this.importType = type;
      this.downloadTemplate();
    },

    /* EXPORT */

    onExportChoose(type) {
      this.importType = type;
      this.downloadTemplate();
    },

    /* FORMS */

    addLocalPersonForm() {
      this.counterpartyForForm = null;
      this.isCounterPartyShow = true;
      this.$modal.show('counterparty-popup');
    },

    editHandler() {
      this.counterpartyForForm = this.counterpartyForContent;
      this.counterpartyVatHistoryList = this.counterpartyForForm.counterpartyVatHistoryList
        ? [...this.counterpartyForForm.counterpartyVatHistoryList]
        : [];
      this.isCounterPartyShow = true;
      this.$modal.show('counterparty-popup');
    },

    closeCounterPartyDialog() {
      this.isCounterPartyShow = false;
      this.counterpartyForForm = null;
      this.$modal.hide('counterparty-popup');
    },

    /* VAT */

    openVatSettings() {
      this.isVatSettingsOpen = true;
      this.$modal.show('vat-settings-popup');
    },

    closeVatSettings() {
      this.isVatSettingsOpen = false;
      this.$modal.hide('vat-settings-popup');
    },

    updateVatRates(rates) {
      this.counterpartyVatHistoryList = rates;
    },

    /* IMPORT CLOSE */

    async closeImportDialog() {
      await this.$store.dispatch('getAllCounterparties');
      this.isShowImportDialog = false;
      this.isShowImportVatDialog = false;
      this.$modal.hide('counterparty-import-popup');
      this.$modal.hide('counterparty-vat-import-popup');
    }
  }
};
</script>
